<script>
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import appConfig from "@/app.config";
import moment from 'moment';

export default {
    page: {
        title: "Outsource Token Calls",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: { Layout, PageHeader },

    data() {
        return {
            title: "Outsource Token Calls",
            items: [
                {
                    text: "Outsource Token Calls",
                    active: true,
                },
            ],
            calls: [],
            counters: [],
            keyword: "",
            counter_id: "",
            date: moment().format('YYYY-MM-DD'),
            listing_length: 10,
            token: "",
            pagination: {},
            from: 0,
            to: 0,
            total: 0,
            loading: false,
            active_page_url: null,
        }
    },
    created() {
        this.fetchCounters();
        this.fetchCalls();
    },
    methods: {
        fetchCounters() {
            this.getToken();
            let url = "pharmacy/counters?limit=100&status=1&keyword=";
            this.$axios
                .get(url, { headers: { Authorization: "Bearer " + this.token } })
                .then((res) => {
                    var responseData = res.data.data;
                    this.counters = responseData.counters.data || [];
                })
                .catch((err) => console.log(err));
        },

        fetchCalls(page_url = null) {
            this.getToken();

            let url = "pharmacy/outsourceTokenCalls?limit=" + this.listing_length +
                "&date=" + this.date +
                "&counter_id=" + (this.counter_id || "") +
                "&keyword=" + encodeURIComponent(this.keyword || "");

            page_url = page_url || url;

            if (localStorage.back_url) {
                page_url = localStorage.back_url;
                localStorage.removeItem('back_url');
            }

            this.active_page_url = page_url;
            this.loading = true;
            this.$axios
                .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
                .then((res) => {
                    var responseData = res.data.data;
                    this.calls = responseData.calls.data;
                    this.from = responseData.calls.from;
                    this.to = responseData.calls.to;
                    this.total = responseData.calls.total;
                    this.pagination = responseData.calls.links;
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                            if (typeof error.response.data.message === 'object') {
                                console.log(error.response.status);
                            } else {
                                this.$swal("", error.response.data.message, "error");
                            }
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));
        },

        getToken() {
            if (localStorage.getItem('medicino_pharmacy')) {
                var medicino_pharmacy = JSON.parse(localStorage.getItem('medicino_pharmacy'));
                if (medicino_pharmacy.token) {
                    this.token = medicino_pharmacy.token;
                } else {
                    this.$swal("", "Failed to fetch token, please login again", "error");
                    this.$router.push({ name: "login" });
                }
            } else {
                this.$swal("", "Session expired, please login again", "error");
                this.$router.push({ name: "login" });
            }
        },

        formatDate(dateString) {
            if (!dateString) return '-';
            const date = new Date(dateString);
            const day = date.getDate();
            const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
            const year = date.getFullYear();
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const ampm = hours >= 12 ? 'PM' : 'AM';
            const displayHours = hours % 12 || 12;
            return `${day} ${month} ${year}, ${displayHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;
        },

        formatCallDate(dateString) {
            if (!dateString) return '-';
            const date = new Date(dateString);
            const day = date.getDate();
            const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
            const year = date.getFullYear();
            return `${day} ${month} ${year}`;
        },

        paginationUrl(page) {
            return page.url +
                '&limit=' + this.listing_length +
                '&date=' + this.date +
                '&counter_id=' + (this.counter_id || '') +
                '&keyword=' + encodeURIComponent(this.keyword || '');
        },
    },
}
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">

                        <!----- Listing length and filters starts ----->
                        <div class="row mb-3">
                            <div class="col-sm-12 col-md-3">
                                <div class="listing-length">
                                    <label>
                                        Show
                                        <select class="form-control" v-model="listing_length" @change="fetchCalls()">
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="15">15</option>
                                        </select>
                                        entries
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-9">
                                <div class="listing-filter">
                                    <label>
                                        <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchCalls()" />
                                    </label>
                                </div>
                                <div class="listing-filter me-2">
                                    <label>
                                        <select class="form-control" v-model="counter_id" @change="fetchCalls()">
                                            <option value="">All Counters</option>
                                            <option v-for="counter in counters" :key="counter.id" :value="counter.id">
                                                {{ counter.counter_name }}
                                            </option>
                                        </select>
                                    </label>
                                </div>
                                <div class="listing-filter me-2">
                                    <label>
                                        <input type="date" class="form-control" v-model="date" @change="fetchCalls()" />
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!----- Listing length and filters ends ----->

                        <!---- listing table starts -------->
                        <div class="table-responsive">
                            <table class="table table-bordered mb-0">
                                <thead class="table-light">
                                    <tr>
                                        <th>Token</th>
                                        <th>Counter</th>
                                        <th>Call Date</th>
                                        <th>Called On</th>
                                    </tr>
                                </thead>
                                <tbody v-if="Boolean(calls.length)">
                                    <tr v-for="call in calls" :key="call.id">
                                        <td>{{ call.token || '-' }}</td>
                                        <td>
                                            <span v-if="call.counter_prefix">{{ call.counter_prefix }} - </span>
                                            {{ call.counter_name || '-' }}
                                        </td>
                                        <td>{{ formatCallDate(call.call_date) }}</td>
                                        <td>{{ formatDate(call.created_at) }}</td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td colspan="4" class="text-center">No outsource token calls found</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!---- listing table ends -------->

                        <!----pagination starts --->
                        <caption v-if="Boolean(calls.length)" class="float-start mt-4 d-block d-lg-inline">
                            Showing {{ from }} to {{ to }} of {{ total }} entries
                        </caption>
                        <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                            <li
                                class="page-item"
                                v-bind:class="[{ disabled: !page.url }, { active: page.active }]"
                                v-for="(page, index) in pagination"
                                :key="page.label"
                            >
                                <a href="#" class="page-link" @click.prevent="fetchCalls(paginationUrl(page))">
                                    <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                                    <i v-else-if="index == pagination.length - 1" class="mdi mdi-chevron-right"></i>
                                    <span v-else>{{ page.label }}</span>
                                </a>
                            </li>
                        </ul>
                        <!----pagination ends --->

                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
